var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    enableBackground: "new 0 0 76.00 76.00",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#211608",
    fillOpacity: 1,
    strokeWidth: 0.2,
    strokeLinejoin: "round",
    d: "M 28.5,60L 22,55.25L 22,25L 27,25L 26.9167,22.1667C 26.9167,17.7944 30.4611,14.25 34.8333,14.25C 38.1014,14.25 40.907,16.2303 42.1156,19.0563C 46.0405,19.5251 49,22.6989 49,26.75L 49,29L 50.75,30L 54,30L 54,60L 28.5,60 Z M 25.3333,32.0625L 27.9583,30.4271L 27.9583,57.25L 28.5,57.7917L 28.5,30.0834L 33,30L 33,27L 24,27L 25.3333,32.0625 Z M 36,27L 36,30L 46,30L 46,28.75L 44,27L 36,27 Z M 43,25L 45.5,25C 45.023,23.6504 44.3496,22.977 43,22.5L 43,25 Z M 30.0833,22.1667L 30,25L 33.25,25C 33.8179,22.2022 36.0197,20.2735 38.6911,19.3948C 37.8287,18.1968 36.4221,17.4167 34.8333,17.4167C 32.21,17.4167 30.0833,19.5433 30.0833,22.1667 Z M 39.75,25L 39.75,22.5C 38.4003,22.977 37.477,23.6503 37,25L 39.75,25 Z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.666555d2dfdc3345535d5134013bbafa.svg";
export { ForwardRef as ReactComponent };